var map = {
	"./logo.svg": 418,
	"./pitch.svg": 417,
	"./soccer-large.svg": 611,
	"./soccer.svg": 1289,
	"./timer.svg": 416,
	"./trotting-dark.svg": 612,
	"./trotting-large.svg": 613,
	"./trotting.svg": 1290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1288;